// ============================================================
// Datei: src/components/modals/ConfirmLeaveShiftModal.jsx
// ============================================================

import React from "react";
import "../../styles/confirmModal.css";

const ConfirmLeaveShiftModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="confirm-modal-backdrop">
            <div className="confirm-modal">
                <h3>Schicht verlassen?</h3>

                <p>
                    Möchtest du diese Schicht wirklich verlassen?  
                </p>

                <div className="confirm-modal-actions">
                    <button className="btn-cancel" onClick={onCancel}>
                        Abbrechen
                    </button>

                    <button className="btn-danger" onClick={onConfirm}>
                        Schicht verlassen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmLeaveShiftModal;
